export default "__VITE_ASSET__8e286064__"